"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pickerStyle = exports.styles = void 0;
var react_1 = require("@emotion/react");
var variables_1 = require("../../../style/variables");
exports.styles = ({
    container: react_1.css({
        cursor: 'pointer',
        backgroundColor: "var(" + variables_1.ComponentColor.Form.Background.BASE + ")",
        color: "var(" + variables_1.ComponentColor.Form.Icon.BASE + ")",
        border: "1px solid var(" + variables_1.RootColor.Gray.LIGHT_2 + ")",
        '&:hover': {
            border: "1px solid var(" + variables_1.ThemeColor.Primary.LIGHT_1 + ")",
        },
        '&:focus-within': {
            border: "1px solid var(" + variables_1.ThemeColor.Primary.LIGHT_1 + ")",
            boxShadow: "var(" + variables_1.Focus.PRIMARY_LIGHT + ")",
        },
    }),
    disabledContainer: react_1.css({
        pointerEvents: 'none',
        color: "var(" + variables_1.ComponentColor.Form.Icon.DISABLED + ")",
        backgroundColor: "var(" + variables_1.ComponentColor.Form.Background.DISABLED + ")",
        borderColor: "var(" + variables_1.ComponentColor.Form.Border.DISABLED + ")",
    }),
    readOnlyContainer: react_1.css({
        pointerEvents: 'none',
        backgroundColor: "var(" + variables_1.ComponentColor.Form.Background.READONLY + ")",
        borderColor: "var(" + variables_1.ComponentColor.Form.Border.READONLY + ")",
    }),
    separator: react_1.css({
        padding: '3px 8px',
    }),
});
exports.pickerStyle = react_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .rc-tooltip-placement-top,\n  .rc-tooltip-placement-bottom {\n    .rc-tooltip-arrow {\n      border: none;\n    }\n    .rc-tooltip-inner {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      padding: 0.5rem 0px 0px;\n      background: #FFFFFF;\n      border: 1px solid var(", ");\n      box-shadow: 0px 20px 24px -4px rgba(0, 0, 0, 0.08), 0px 8px 8px -4px rgba(0, 0, 0, 0.03);\n      border-radius: 0.5rem;\n      margin-top: 0.5rem;\n      margin-bottom: 0.5rem;\n    }\n  }\n"], ["\n  .rc-tooltip-placement-top,\n  .rc-tooltip-placement-bottom {\n    .rc-tooltip-arrow {\n      border: none;\n    }\n    .rc-tooltip-inner {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      padding: 0.5rem 0px 0px;\n      background: #FFFFFF;\n      border: 1px solid var(", ");\n      box-shadow: 0px 20px 24px -4px rgba(0, 0, 0, 0.08), 0px 8px 8px -4px rgba(0, 0, 0, 0.03);\n      border-radius: 0.5rem;\n      margin-top: 0.5rem;\n      margin-bottom: 0.5rem;\n    }\n  }\n"])), variables_1.RootColor.Gray.LIGHT_4);
var templateObject_1;
